import * as React from 'react';

export interface FilterBadge {
  label: string;
  value: string;
  color: 'blue' | 'green' | 'yellow' | 'purple' | 'red';
}

export interface ActiveFiltersBadgesProps {
  filters: FilterBadge[];
}

const colorClasses = {
  blue: 'bg-blue-100 text-blue-800',
  green: 'bg-green-100 text-green-800',
  yellow: 'bg-yellow-100 text-yellow-800',
  purple: 'bg-purple-100 text-purple-800',
  red: 'bg-red-100 text-red-800',
};

export const ActiveFiltersBadges: React.FC<ActiveFiltersBadgesProps> = ({
  filters,
}) => {
  const activeFilters = filters.filter(f => f.value);

  if (activeFilters.length === 0) return null;

  return (
    <div className='flex items-center space-x-2 text-sm text-grey-600'>
      <span>Active filters:</span>
      {activeFilters.map((filter, index) => (
        <span
          key={index}
          className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${colorClasses[filter.color]}`}
        >
          {filter.label}: {filter.value}
        </span>
      ))}
    </div>
  );
};
